const MyLocationIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.375 1.875V3.16406C6.08154 3.46191 3.46191 6.08398 3.16406 9.375H1.875V10.625H3.16406C3.46191 13.916 6.08398 16.5381 9.375 16.8359V18.125H10.625V16.8359C13.916 16.5381 16.5381 13.916 16.8359 10.625H18.125V9.375H16.8359C16.5381 6.08398 13.9185 3.46191 10.625 3.16406V1.875H9.375ZM9.375 4.39453V5.625H10.625V4.39453C13.2446 4.67773 15.3003 6.75537 15.5859 9.375H14.375V10.625H15.6055C15.3223 13.2446 13.2446 15.3223 10.625 15.6055V14.375H9.375V15.6055C6.75537 15.3223 4.67773 13.2446 4.39453 10.625H5.625V9.375H4.41406C4.69971 6.75537 6.75537 4.67773 9.375 4.39453ZM10 7.5C8.61816 7.5 7.5 8.61816 7.5 10C7.5 11.3818 8.61816 12.5 10 12.5C11.3818 12.5 12.5 11.3818 12.5 10C12.5 8.61816 11.3818 7.5 10 7.5Z"
        fill="#251000"
        fill-opacity="0.56"
      />
    </svg>
  )
}

export default MyLocationIcon
